/* eslint-disable new-cap */
import { Result } from '@/modules/errorHandling/results'
import { MessageBox, Message } from 'element-ui'
import { ElMessageBoxOptions } from 'element-ui/types/message-box'

const options: ElMessageBoxOptions = {
  confirmButtonText: 'OK',
  cancelButtonText: 'Cancel',
  type: 'warning'
}

interface ConfirmationParams {
  question: string
  messageFail?: string
  title?: string
  action: () => Promise<void>
  options?: ElMessageBoxOptions
}

const askConfirmation = async (params: ConfirmationParams) => {
  try {
    await MessageBox.confirm(params.question, params.title ?? 'Warning', params.options ?? options)
  } catch (error) {
    if (error === 'cancel') {
      return Result.success(false)
    } else {
      console.error('Confirmation box error:', error)
      return Result.fail('no_confirm', `Confirmation box error: ${error}`)
    }
  }
  try {
    await params.action()
    return Result.success(true)
  } catch (error) {
    Message({
      type: 'error',
      message: params.messageFail ?? `action failed: ${error}`
    })
    return Result.fail('no_confirm', `Action failed: ${error}`)
  }
}

const useConfirmation = () => {
  return {
    askConfirmation
  }
}

export default useConfirmation

